import { UtilService } from './../../../shared/services/util/util.service';
import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-causes',
  templateUrl: './causes.component.html',
  styleUrls: ['./causes.component.scss'],
})
export class CausesComponent implements OnInit {
  lazyLoadImage = 'assets/images/homepage/Causes2019.png';
  isMobile: any;

  constructor(
    private utilService: UtilService
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
  }

}
